/*********************************************************************
	画像切替
*********************************************************************/
function smartRollover() {
	if(document.getElementsByTagName) {
		var images = document.getElementsByTagName("img");

		for(var i=0; i < images.length; i++) {
			if(images[i].getAttribute("src").match("_rof."))
			{
				images[i].onmouseover = function() {
					this.setAttribute("src", this.getAttribute("src").replace("_rof.", "_ron."));
				}
				images[i].onmouseout = function() {
					this.setAttribute("src", this.getAttribute("src").replace("_ron.", "_rof."));
				}
			}
		}
	}
}

if(window.addEventListener) {
	window.addEventListener("load", smartRollover, false);
}
else if(window.attachEvent) {
	window.attachEvent("onload", smartRollover);
}

/*********************************************************************
	タブ切り替え
*********************************************************************/
var Tab = {
	init: function(){
		var tabs = this.setup.tabs;
		var pages = this.setup.pages;
		var dsppage = location.hash;
		
		var param = GetQueryString();
		var dsppage = "";

		if( param !== null && param["h"] !== undefined ) {
		  dsppage = param["h"];
		}

		for(i=0; i<pages.length; i++) {
			if( ( dsppage == "" && i == 0 ) || pages[i].id == dsppage ) {
				pages[i].style.display = 'block';
				tabs[i].className = 'open';
			} else {
				pages[i].style.display = 'none';
				tabs[i].className = null;
			}
			tabs[i].onclick = function(){ Tab.showpage(this); return false; };
		}
	},
	showpage: function(obj){
		var tabs = this.setup.tabs;
		var pages = this.setup.pages;
		var num;
		
		for(num=0; num<tabs.length; num++) {
			if(tabs[num] === obj) break;
		}
		
		for(var i=0; i<pages.length; i++) {
			if(i == num) {
				pages[num].style.display = 'block';
				tabs[num].className = 'open';
			}
			else{
				pages[i].style.display = 'none';
				tabs[i].className = null;
			}
		}
	}
}

function GetQueryString() {
  if (1 < document.location.search.length) {
    // 最初の1文字 (?記号) を除いた文字列を取得する
          var query = document.location.search.substring(1);
           
    //           // クエリの区切り記号 (&) で文字列を配列に分割する
          var parameters = query.split('&');
                     
          var result = new Object();
          for (var i = 0; i < parameters.length; i++) {
    //    // パラメータ名とパラメータ値に分割する
               var element = parameters[i].split('=');
                                           
               var paramName = decodeURIComponent(element[0]);
               var paramValue = decodeURIComponent(element[1]);
    //                                                    
    //     // パラメータ名をキーとして連想配列に追加する
               result[paramName] = decodeURIComponent(paramValue);
           }
           return result;
  }
  return null;
}

/*********************************************************************
	レビュー投稿フォーム用
*********************************************************************/
/* 評価の★をクリックした時の表示位置 */
function switch_rating(id,i) {
	$('review-eval'+id).value = i;
	$('rating'+id).setStyle('width', i*20+'%');
	var forminput = document.getElementById("rating"+id+"_check");
	forminput.className = "forminput_OK";
}

/* 商品レビュー投稿フォームのショップレビュー箇所の出しわけ */
function radiochange(num) {
	var elNum = 2;
	
	var shopReviewEl = document.getElementById('shop-review-form');
	if( num == 1 ) {
		// Display Shop Review
		shopReviewEl.style.display ='block';
		var imgAr = new Array ("b","a");
	} else {
		// Hidden Shop Review
		shopReviewEl.style.display ='none';
		var imgAr = new Array ("a","b");
	}

	for(var i = 1;i<= elNum;i++ ) {
		var el = document.getElementById('img1_'+i);
		el.src = el.src.replace(/\-[ab](_...\.jpg)/,"-"+imgAr[i-1]+"$1");
	}

	document.getElementById('review_sw').value = num;
}

/*********************************************************************
	ページTOPへのページ内リンク用
*********************************************************************/
function toPageTop() {
	window.location.hash='';
	window.location.hash="up";
}

/*********************************************************************
	チェックボックスで表示or非表示の切り替え
*********************************************************************/
function chkdisp( obj,id ) {
	if( obj.checked ){
		document.getElementById(id).style.display = "block";
	}
	else {
		document.getElementById(id).style.display = "none";
	}
}




/*********************************************************************
	スムーススクロール
*********************************************************************/
var ATScroll = function(vars) {
	//コンストラクタ
	var _self = this;
	var _timer;

	//デフォルトオプション
	var options = {
		noScroll : 'noSmoothScroll',
		setHash : false,
		duration : 800,
		interval : 10,
		animation : 'liner',
		callback : function(){}
	};

	//オプションの上書き設定
	this.config = function(property) {
		for (var i in property) {
			//設定されていない時は上書きしない
			if (!vars.hasOwnProperty(i)) {
				continue;
			}
			options[i] = property[i];
		}
	}

	//ブラウザチェック
	var browser = {
		ua : function() {
			return navigator.userAgent;
		},
		//IE
		ie : function() {
			return browser.ua.indexOf('MSIE') >= 0;
		},
		//IE6
		ie6 : function() {
			return browser.ua.indexOf('MSIE 6') >= 0;
		},
		//標準モード
		ieStandard : function() {
			return (document.compatMode && document.compatMode == 'CSS1Compat');
		}
	};

	//スクロール位置の取得
	var scroll = {
		top : function() {
			return (document.documentElement.scrollTop || document.body.scrollTop);
		},
		left : function() {
			return (document.documentElement.scrollLeft || document.body.scrollLeft);
		},
		width : function() {
			if (browser.ie && !browser.ieStandard) {
				return document.body.scrollWidth;
			}
			//モダンブラウザ
			else {
				return document.documentElement.scrollWidth;
			}
		},
		height : function() {
			if (browser.ie && !browser.ieStandard) {
				return document.body.scrollHeight;
			}
			//モダンブラウザ
			else {
				return document.documentElement.scrollHeight;
			}
		}
	};

	//ウインドウのサイズ取得
	var inner = {
		width : function() {
			//モダン
			if (window.innerWidth) {
				return window.innerWidth;
			}
			//IE
			else if (browser.ie) {
				//IE6 && 標準モード
				if (browser.ie6 && browser.ieStandard) {
					return document.documentElement.clientWidth;
				}
				//IE6互換モード && 他IE
				else {
					//IE6以下
					if (!document.documentElement.clientWidth) {
						return document.body.clientWidth;
					}
					//IE6以上
					else {
						return document.documentElement.clientWidth;
					}
				}
			}
		},
		height : function() {
			//モダン
			if (window.innerHeight) {
				return window.innerHeight;
			}
			//IE
			else if (browser.ie) {
				//IE6 && 標準モード
				if (browser.ie6 && browser.ieStandard) {
					return document.documentElement.clientHeight;
				}
				//IE6互換モード && 他IE
				else {
					//IE6以下
					if (!document.documentElement.clientHeight) {
						return document.body.clientHeight;
					}
					//IE6以上
					else {
						return document.documentElement.clientHeight;
					}
				}
			}
		}
	};

	//オブジェクト位置の取得
	this.getElementPosition = function(ele) {
		var obj = new Object();
		obj.x = 0;
		obj.y = 0;

		while(ele) {
			obj.x += ele.offsetLeft || 0;
			obj.y += ele.offsetTop || 0;
			ele = ele.offsetParent;
		}
		return obj;
	}


	//イベント追加
	this.addEvent = function(eventTarget, eventName, func) {
		// モダンブラウザ
		if(eventTarget.addEventListener) {
			eventTarget.addEventListener(eventName, func, false);
		}
		// IE
		else if(window.attachEvent) {
			eventTarget.attachEvent('on'+eventName, function(){func.apply(eventTarget);});
		}
	}

	//イベントキャンセル
	this.eventCancel = function(e) {
		//for IE
		if (!e) e = window.event;

		if (e.preventDefault) {
			e.preventDefault()
		}
		else{
			e.returnValue = false;
		}
	}

	this.setSmoothScrollY = function(e) {
		_self.eventCancel(e);
		clearTimeout(_timer);
		var hash = this.hash;
		var idName = hash.replace('#', '');
		var targetId = document.getElementById(idName);

		//var toX = _self.getElementPosition(targetId).x;
		var toY = _self.getElementPosition(targetId).y;

		//リンク先が範囲外時
		var limitH = scroll.height() - inner.height();
		if (limitH < toY) {
			toY = limitH;
		}
		if (toY < 0) {
			toY = 0;
		}

		if (options.setHash) {
			options.callback = function(){
				window.location.hash = hash;
			}
		}
		_self.scroll(toY);
	}

	var easing = {
		/*
		time = 現在秒 (現在
		begin = 最初の値
		change = 変動する値
		duration = 何秒かけて動くか
		*/
		liner : function(t, b, c, d) {
			return c * t / d + b;
		},
		quinticIn : function(t, b, c, d) {
			t /= d;
			return c * t * t * t * t * t + b;
		},
		quinticOut : function(t, b, c, d) {
			t /= d;
			t = t - 1;
			return -c * (t * t * t * t - 1) + b;
		}
	};

	this.scroll = function(toY) {
		var now = new Date();
		var fromY = scroll.top();
		var run = function() {
			var time = new Date() - now;
			var next = easing[options.animation](time, fromY, toY - fromY, options.duration);

			if (time < options.duration - options.interval) {
				window.scrollTo(scroll.left(), parseInt(next));
				_timer = setTimeout(function(){run()}, options.interval);
			}
			else {
				clearTimeout(_timer);
                                var nav = document.getElementById('header-navi-ink');
                                if(nav){
                                    var toTop = document.getElementById('up').offsetTop;
				    if(toY > toTop){
                                        if(nav.style.display != "none"){ headerNaviInkMove = 0;pageLinkClick=false;headerNaviInkMoveTmp=toY;}
                                    }
                                }
				window.scrollTo(scroll.left(), parseInt(toY));
				options.callback();
			}
		}
		run();
	}

	this.load = function() {
		//コンストラクタ
		this.config(vars);

		this.addEvent(window, 'load', function() {
			var allLinks = document.links;

			//ページ内リンク — CHỈ bắt link trỏ về chính trang đang mở.
			//Bản gốc chỉ kiểm tra `getElementById(hash)`: link SANG TRANG KHÁC nhưng trùng
			//tên anchor (vd đang ở /pages/hp#PageScroll__Printer, bấm
			///pages/canon#PageScroll__Printer) cũng khớp → setSmoothScrollY preventDefault
			//→ chỉ cuộn trong trang, không bao giờ chuyển trang.
			var isSamePageLink = function(link) {
				var linkPath = ('/' + link.pathname).replace(/^\/+/, '/');
				var herePath = ('/' + window.location.pathname).replace(/^\/+/, '/');
				return link.hostname === window.location.hostname
					&& linkPath === herePath
					&& link.search === window.location.search;
			};

			for (var i = 0; i < allLinks.length; i++) {
				var a = allLinks[i]
				var hash = a.href.split('#')[1];

				if (a.className.indexOf(options.noScroll) >= 0) {
					continue;
				}
				if (hash && isSamePageLink(a) && document.getElementById(hash)) {
					_self.addEvent(a, 'click', _self.setSmoothScrollY);
				}
			}
		});
	}
};

var atscroll = new ATScroll({
	noScroll : 'noSmoothScroll',
	setHash : false,
	duration : 600,
	interval : 10,
	animation : 'quinticOut'
});
atscroll.load();
